import React from "react";
import "./mcp-connect.scss";
import User from "../../models/User";
import {ApiEngine} from "api-engine";
import { hapticSelect, hapticSuccess } from "../../utils/haptic";

interface McpConnectProps {
  user: User;
  api: ApiEngine;
}

interface McpConnectState {
  copied: boolean;
}

export default class McpConnect extends React.Component<McpConnectProps, McpConnectState> {
  copyResetTimer: ReturnType<typeof setTimeout> | null = null;

  constructor(_props: McpConnectProps) {
    super(_props);
    this.state = {
      copied: false
    };
    this.copyUrl = this.copyUrl.bind(this);
  }

  componentWillUnmount() {
    if (this.copyResetTimer) clearTimeout(this.copyResetTimer);
  }

  // The full URL is a bearer credential — it is only ever put into the
  // clipboard, never rendered, logged or sent to analytics.
  mcpUrl(): string | null {
    let me = this;
    if (me.props.user.id === null || !me.props.user.mcpToken) return null;
    return `${me.props.api.serverUrl}/api/mcp/${me.props.user.id}?token=${me.props.user.mcpToken}`;
  }

  maskedMcpUrl(): string | null {
    let me = this;
    if (me.props.user.id === null || !me.props.user.mcpToken) return null;
    return `${me.props.api.serverUrl}/api/mcp/${me.props.user.id}?token=••••••••`;
  }

  copyUrl() {
    let me = this;
    let url = me.mcpUrl();
    if (!url) return;
    hapticSelect();

    let markCopied = () => {
      hapticSuccess();
      me.setState({copied: true}, () => {
        if (me.copyResetTimer) clearTimeout(me.copyResetTimer);
        me.copyResetTimer = setTimeout(() => {
          me.setState({copied: false});
        }, 2000);
      });
    };

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(url).then(markCopied).catch(() => {});
    } else {
      let textArea = document.createElement("textarea");
      textArea.value = url;
      textArea.style.position = "fixed";
      textArea.style.opacity = "0";
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
        markCopied();
      } catch (e) {
      }
      document.body.removeChild(textArea);
    }
  }

  render() {
    let me = this;
    let maskedUrl = me.maskedMcpUrl();

    if (!maskedUrl) return <></>;

    return <div className={"mcp-connect"}>
      <span className={"label"}>MCP</span>
      <input type={"text"} readOnly value={maskedUrl} onFocus={(_e) => _e.target.select()}/>
      <button className={me.state.copied ? "copy-btn copied" : "copy-btn"} onClick={me.copyUrl}>
        {me.state.copied ? "Скопировано" : "Копировать"}
      </button>
    </div>
  }
}
